import React from "react";
import { Modal, Button, ControlLabel, FormControl, FormGroup } from "react-bootstrap";
import { isValidPhoneNumber, maskEmail, validatePhoneNumber } from "../../lib/utils";
import FieldGroup from "../fragments/FieldGroup";
import ProcessesStatus from "../fragments/ProcessesStatus";
import './index.css';

class PhoneNumberForm extends React.Component {

  state = {
    error: '',
  };

  validateVerificationCode = verificationCode => {
    const regexp = new RegExp("^(?=.*[0-9])(?=\\S+$).{6}$");
    return verificationCode === '' ? null : (regexp.test(verificationCode) ? 'success' : 'error');
  }

  /**
   * Save on the server
   */
  doSavePhoneNumber = phoneNumber => {

    this.setState({ error: null });
    if(isValidPhoneNumber(phoneNumber) === 'success') {
      this.props.savePhoneNumber(phoneNumber);
    }
    else {
      this.setState({ error: 'The phone number is incorrect.' });
    }
  }

  sendVerificationCode = verificationCode => {

    if(this.validateVerificationCode(verificationCode) === 'success') {
      this.setState({ error: null });
      this.props.sendPhoneNumberValidationCode(verificationCode);
    }
    else {
      this.setState({ error: 'Please enter a 6-digit code!' });
    }
  }

  resendVerifCodeAction = () => {
    this.setState({ error: null });
    this.props.resendVerifCode();
  }

  handleClose = () => {
    this.setState({ error: null });
    this.props.handleClose();
  }

  renderValidatePhoneNumber = () => {

    const { email, verificationCode, setVerificationCode, runningResend, isProcessRunning,
      resendText, retryIn } = this.props;

    return (
      <div id='validate-phone-number'>
        <FormGroup controlId="verificationCode" validationState={ this.validateVerificationCode(verificationCode) }>

          <p className="verif-text-msg">
          { runningResend 
            ? <span>Sending an email to { maskEmail(email) } ..</span>
            : <span>An email with a verification code was sent to 
              &nbsp;<strong>{ maskEmail(email) }</strong></span>
          }
          </p>

          <ControlLabel>Enter your verification code</ControlLabel>

          <FormControl type="number" placeholder="Enter the 6-digit code"
            value={ verificationCode }
            min='1'
            autoFocus
            onChange={ e => setVerificationCode(e.target.value) }
          />
          <FormControl.Feedback />

        </FormGroup>

        <p className='resend'>
          Didn't receive the code?&nbsp;
          { runningResend || isProcessRunning
            ? <span>Waiting..</span>
            : resendText
            ? <span onClick={ this.resendVerifCodeAction } title='Resend the verification code to my email address.' 
              className='resend-action cursor-pointer'>Click to resend</span>
            : <span title='Please wait!'>Resend in { retryIn }s</span>
          }
        </p>
      </div>
    )
  }

  render() {

    const { show, title, operationNumber, phoneNumber, setPhoneNumber, isProcessFailed,
      isProcessRunning, isProcessSuccessful, runningResend, isPhoneNumberChanged, buttonText,
      verificationCode } = this.props;

    const { error } = this.state;
  
    return (
      <Modal show={ show } onHide={ this.handleClose } >

        <Modal.Header closeButton>
          <Modal.Title>{ title }</Modal.Title>
        </Modal.Header>

        <Modal.Body>

          { operationNumber === 2 
          ? this.renderValidatePhoneNumber()
          : <FieldGroup
              id="phoneNumber"
              className="p-20"
              type="text"
              label="Phone number"
              placeholder="+358 45 893 28 60"
              validationState={ validatePhoneNumber(phoneNumber) }
              value={ phoneNumber ? phoneNumber : '' }
              autoFocus
              onChange={e => setPhoneNumber(e.target.value)}
          />
          }

          <ProcessesStatus
            error={ error ? error : isProcessFailed ? isProcessFailed : null }
            running={ isProcessRunning }
            success={ isProcessSuccessful }
          />

        </Modal.Body>

        <Modal.Footer>

          <Button onClick={ this.handleClose }>Close</Button>

          <Button onClick={() => operationNumber === 2 
            ? this.sendVerificationCode(verificationCode) : this.doSavePhoneNumber(phoneNumber) } 
            bsStyle="primary"
            disabled={ isProcessRunning || runningResend || (operationNumber === 1 && !isPhoneNumberChanged) }>
            { buttonText }
          </Button>

        </Modal.Footer>
      </Modal>
    )
  }
}

export default PhoneNumberForm;



// WEBPACK FOOTER //
// ./src/components/MyAccount/PhoneNumberForm.js